// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyBOl4qPG_P8sAhQ4a5aW00KLygTZmmn1CM",
    authDomain: "tovo-beach.firebaseapp.com",
    projectId: "tovo-beach",
    storageBucket: "tovo-beach.appspot.com",
    messagingSenderId: "725545033887",
    appId: "1:725545033887:web:7e42027cdc10d72a1e02aa",
    measurementId: "G-H817JTC6EK"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
